const swiper = new Swiper(".psb_media", {
  loop: true,
  slidesPerView: "auto",
  slidesPerGroup: true,
  pagination: {
    el: ".psb_media .swiper-pagination",
  },
  navigation: {
    nextEl: ".psb_media .swiper-button-next",
    prevEl: ".psb_media .swiper-button-prev",
  },
});

$(document).ready(function () {
  if (typeof $.fn.magnificPopup !== "function") return;
  $(".popup-gallery").magnificPopup({
    delegate: "a",
    type: "image",
    mainClass: "mfp-img-mobile",
    gallery: {
      enabled: true,
      navigateByImgClick: true,
      preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
    },
  });
});
